import ContactsBaseDetailsPageController from './base';

export default class ContactsDetailsInvoicesPageController extends ContactsBaseDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/details/invoices.js